import { LeaveApprovalStatusEnum } from "@gtpl/shared-models/common-models";
import { Column, Entity, PrimaryGeneratedColumn, VersionColumn, UpdateDateColumn, CreateDateColumn } from "typeorm";

@Entity('attendance_adjustment')
export class AttendanceAdjustment {

    @PrimaryGeneratedColumn('increment', {
        name: 'id'
    })
    id: number;

    @Column('int', {
        name: 'attendace_id'
    })
    attendaceId: number;

    @Column('int', {
        nullable: false,
        name: 'employee_id'
    })
    employeeId: number;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_code'
    })
    employeeCode: string;

    @Column('varchar', {
        nullable: false,
        length: 40,
        name: 'employee_name'
    })
    employeeName: string;

    @Column('varchar', {
        nullable: false,
        name: 'date'
    })
    date: string;

    @Column({
        name: 'old_in_time'
    })
    oldInTime: Date;

    @Column({
        name: 'in_time'
    })
    inTime: Date;

    @Column({
        name: 'old_out_time'
    })
    oldOutTime: Date;

    @Column({
        name: 'out_time'
    })
    outTime: Date;

    @Column("varchar", {
        name: 'present_status'
    })
    presentStatus: string;

    @Column("int", {
        nullable: false,
        name: "department_id"
    })
    departmentId: number;

    @Column("varchar", {
        nullable: false,
        name: "shift_group"
    })
    shiftGroup: string;

    @Column("int", {
        name: 'unit_id'
    })
    unitId: number;

    @Column('varchar', {
        nullable: false,
        length: 10,
        name: 'shift'
    })
    shift: string;

    @Column('varchar', {
        nullable: true,
        name: 'reason'
    })
    reason: string;

    @Column("varchar", {
        nullable: true,
        name: "remarks"
    })
    remarks: string;

    @Column({
        name: 'applied_date'
    })
    appliedDate: Date;

    @Column({
        type: 'enum',
        enum: LeaveApprovalStatusEnum,
        nullable: true,
        default: LeaveApprovalStatusEnum.OPEN,
        name: 'status'
    })
    status: LeaveApprovalStatusEnum;

    @Column("varchar", {
        nullable: false,
        length: 40,
        name: 'created_user'
    })
    createdUser: string | null;

    @CreateDateColumn({
        name: "created_at",
        type: 'datetime'
    })
    createdAt: Date;

    @Column("varchar", {
        nullable: true,
        length: 40,
        name: "updated_user"
    })
    updatedUser: string | null;

    @UpdateDateColumn({
        name: "updated_at",
        type: 'datetime'
    })
    updatedAt: Date;

    @VersionColumn({
        default: 1,
        name: 'version_flag'
    })
    versionFlag: number;

}